import { FIN_QRC_MOVEMENTS_ITEM } from './fin-qrc-movements.js'
import { FIN_QRC_CONFIGS_ITEM } from './fin-qrc-configs.js'

/** @type {import('../help-index.js').HelpScreen} */
export const FIN_QRC_HELP = {
  screenId: 'fin-qrc',
  label: 'Cobros QR',
  navPath: 'Finanzas → Cobros QR',
  keywords: [
    'cobro qr', 'qr', 'mercado pago', 'modo', 'pago qr', 'transferencia qr',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Configurá puntos de cobro QR (cuenta bancaria, fee y costo de comisión) y consultá los movimientos generados al registrar cobros con ese medio.',
  sidebarItems: [FIN_QRC_MOVEMENTS_ITEM, FIN_QRC_CONFIGS_ITEM],
}
